/*
 * @Author: ningbo.kang
 * @Date: 2020-04-07 13:33:39
 * @LastEditors: error: git config user.email & please set dead value or install git
 * @LastEditTime: 2023-03-31 15:39:33
 * @Description: 描述
 */
import widgetOptions from './widgetOptions';
import { t } from '../locale';
import { getLangValue } from './index';

export default {
  data() {
    const {
      widget: { rules, options },
    } = this;
    return {
      rules,
      required: options.required,
      disabled: options.disabled,
    };
  },
  inject: ['formContext'],
  props: {
    value: {},
    // 组件是字段名
    fieldName: {
      type: String,
      default: '',
    },
    widget: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否嵌套在子表
    isNested: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    // 子表格行索引
    rowIndex: {
      type: Number,
      default: -1,
    },
    // 嵌套时，父节点字段名,不包括[]，比如 mytable
    parentName: {
      type: String,
      default: '',
    },
    // 嵌套时，父节点字段名，比如 mytable[1]
    parentModel: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default() {
        return process.env.VUE_APP_DEFAULT_LANG;
      },
    },
  },
  watch: {
    'options.required': {
      handler(val) {
        this.handleNoticeParent({ required: val });
      },
      immediate: true,
    },
    'options.disabled': {
      handler(val) {
        this.handleNoticeParent({ disabled: val });
      },
    },
  },
  computed: {
    options() {
      return this.widget.options;
    },
    // 表单项装饰器，很关键
    decorator() {
      // 读取校验过后的字段名，因为有可能字段名this.widget.model是数组，比如 `xyz[0]`形式，需要取出`xyz`
      const { type, model } = this.widget;
      let fieldName = model;
      // 子表内嵌套字段重新组装名称 mytable[0].userName
      if (this.isNested) {
        fieldName = `${this.parentModel}.${model}`;
      }
      // 如果是子表单，则生成对应辅助字段
      if (type === 'table') {
        fieldName = `$__${model}`;
      }
      // 其他规则
      // const otherRules = {};
      // else if (type === 'fileupload') {
      //   otherRules.valuePropName = 'fileList';
      //   otherRules.getValueFromEvent = this.normFile;
      // }
      // 重新组装合并结果输出
      const rules = this.rules.filter(rule => Object.keys(rule).length > 0);
      if (type === 'fileupload') {
        rules.forEach((item) => {
          if (item.required) {
            item.validator = this.validatorArrayString;
          }
        });
      }
      // 修正校验规则中多语言
      rules.forEach((item) => {
        if (item.required) {
          item.message = this.t('wg.required', [this.label]);
        }
        if (item.type) {
          item.message = this.t('wg.invalidType');
        }
      });
      return [
        fieldName,
        {
          rules,
          initialValue: this.defaultValue,
        },
      ];
    },
    // 表单项标签名
    label() {
      // return this.showLabel ? this.widget.name : '';
      if (this.showLabel) {
        if (this.widget.i18nTitle) {
          return this.widget.i18nTitle;
        }
        if (this.widget.langTitle) {
          return getLangValue(this.widget.langTitle, this.lang);
        }
        return this.widget.name;
      }
      return '';
    },
    placeholder() {
      // 后端国际化配置
      if (this.widget.i18nPlaceholder) {
        return this.widget.i18nPlaceholder;
      }
      // 前端国际化配置
      if (this.widget.langPlaceholder) {
        return getLangValue(this.widget.langPlaceholder, this.lang);
      }
      // 直接获取表单配置
      return this.widget.options.placeholder;
    },
    rangePlaceholder() {
      if (this.widget.i18nStartPlaceholder || this.widget.i18nEndPlaceholder) {
        return [this.widget.i18nStartPlaceholder, this.widget.i18nEndPlaceholder];
      }
      if (this.widget.langStartPlaceholder || this.widget.langEndPlaceholder) {
        return [getLangValue(this.widget.langStartPlaceholder, this.lang), getLangValue(this.widget.langEndPlaceholder, this.lang)];
      }
      return [];
    },
    defaultValue() {
      const { options, type } = this.widget;
      // 配置默认值
      const configDefaultValue = widgetOptions[type].defaultValue;
      // if (type === 'select' && options.multiple) {
      //   configDefaultValue = widgetOptions[type].multiple.defaultValue;
      // }
      // 从 字段设置默认值 或 配置默认值 去除默认值
      if (Object.prototype.hasOwnProperty.call(options, 'defaultValue')) {
        return options.defaultValue;
      }
      return configDefaultValue;
    },
  },
  methods: {
    t(...args) {
      return t.apply(this, args);
    },
    // normFile(e) {
    //   if (Array.isArray(e)) {
    //     return e;
    //   }
    //   return e && e.fileList;
    // },
    // 向上抛出数据
    handleChange(val, otherVal) {
      this.$emit('change', val, otherVal);
    },
    handleConfirm(val) {
      this.$emit('confirm', val);
    },
    handleNoticeParent(val) {
      if (Object.prototype.hasOwnProperty.call(val, 'required')) {
        const otherRules = this.rules.filter(
          item => !Object.prototype.hasOwnProperty.call(item, 'required'),
        );
        let message;
        const { required = false } = val;
        if (required) {
          // message = `${this.widget.name}必须填写`;
          message = this.t('wg.required', [this.widget.name]);
        }
        this.rules = [{ required, message }, ...otherRules];
        this.required = required;
      }
      if (Object.prototype.hasOwnProperty.call(val, 'disabled')) {
        this.disabled = val.disabled;
      }
      if (Object.prototype.hasOwnProperty.call(val, 'rules')) {
        const { ruleId, rule, opt } = val.rules;
        if (opt === 'add') {
          this.addRule(ruleId, rule);
        } else if (opt === 'remove') {
          this.removeRule(ruleId);
        }
      }
    },
    addRule(ruleId, rule) {
      let existRule = this.rules.find(item => item.id === ruleId);
      if (existRule) {
        existRule = {
          id: ruleId,
          ...rule,
        };
      } else {
        this.rules.push({
          id: ruleId,
          ...rule,
        });
      }
    },
    removeRule(ruleId) {
      const index = this.rules.findIndex(item => item.id === ruleId);
      this.rules.splice(index, 1);
    },
    // 自定义校验器，如果是字符串数组 "[]"
    validatorArrayString(rule, value, callback) {
      if (value) {
        if (JSON.parse(value).length > 0) {
          callback();
          return;
        }
      }
      callback(rule.message);
    },
    remote() {
      if (this.formContext) {
        return this.formContext.remote;
      }
      return {};
    },
  },
};
